<template>
  <v-container>
    <v-row>
      <v-col>
        <FileUploader
          :save-activated="userClickedSave"
          :edited-object-id="docketEntry.id"
          for-data-type="docketEntries"
          :existing-files="docketEntry.files"
          :file-previews="filePreviews"
          @is-valid-update="updateFileUploadValid"
          @files-updated="updateFilesAreSelected"
          @on-prepare="saveEntry"
          @preview-fetched="emitFilePreviewUpdate"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

import { alertHandler } from '@/alertHandler'

import FileUploader from '@/components/Misc/FileUploader'

import { DOCKET_ENTRY_NAMESPACE } from '@/store/docket-entry'

export default {
  name: 'DocketEntryEditorAttachments',

  components: {
    FileUploader,
  },

  props: {
    saveActivated: {
      type: Boolean,
      required: true,
    },
  },

  setup () {
    return {
      ...alertHandler(),
    }
  },

  data () {
    return {
      filePreviews: [],
      userClickedSave: false,
    }
  },

  computed: {
    docketEntry () {
      return this.editedDocketEntry
    },

    ...mapGetters(DOCKET_ENTRY_NAMESPACE, [
      'editedDocketEntry',
    ]),
  },

  watch: {
    saveActivated (val) {
      this.userClickedSave = val
    },
  },

  created () {
  },

  methods: {
    emitFilePreviewUpdate (filePreview) {
      this.$emit('preview-fetched', filePreview)
    },

    saveEntry (filesToUpload) {
      this.$emit('on-prepare', filesToUpload)
    },

    updateFileUploadValid (alert) {
      if (alert.alertType && alert.alertMessage) this.displayAlert(alert.alertType, alert.alertMessage)
    },

    updateFilesAreSelected (filesSelected) {
      this.$emit('files-updated', filesSelected)
    },
  },
}
</script>
